import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isOpen", "renderExtraOptions", "playlistId", "trackId", "lessonId", "shortId", "language", "onOpenChange"];
import getLang from 'LearningCenterUI/utils/getLang';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import { LikeLink, RouterLink } from '../../../components/AcademyLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import MobileNestedMenu, { CaretForward } from '../../../components/Modals/FullScreenModal/MobileNestedMenu';
import PanelSection from '../../../components/Modals/FullScreenModal/PanelSection';
import styled, { css, theme } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import { AddToPlaylist, CardMenuWatchLaterOption, ChangePlaylistThumbnail, CreatePlaylistLink, EditPlaylistButton, useUserOwnsPlaylist, StartPlaylistButton, UploadPlaylistThumbnailButton } from '../../savedItems';
import { MobileSocialShareMenuOption, ShareButton } from '../../share';
import { DuplicatePlaylistButton } from '../../savedItems/components/DuplicatePlaylistButton';
import { ArchivePlaylistButton, SavePlaylistButton } from '../../myPlaylists';
import { AssignPlaylistButton, PlaylistAssignmentsSearchProvider, UnAssignPlaylist, UnassignPlaylistHeader, UnassignPlaylistLoadMore } from '../../playlistAssignments';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MenuRowStyle = css(["display:flex;flex-grow:1;justify-content:space-between;font-weight:initial;padding:12px 20px !important;"]);
export const MenuRow = styled.div.withConfig({
  displayName: "MobileCardMenu__MenuRow",
  componentId: "g7k8bx-0"
})(["", ""], MenuRowStyle);
export const MenuButton = styled(UIButton).withConfig({
  displayName: "MobileCardMenu__MenuButton",
  componentId: "g7k8bx-1"
})(["", ""], MenuRowStyle);
export const MenuLink = styled(RouterLink).withConfig({
  displayName: "MobileCardMenu__MenuLink",
  componentId: "g7k8bx-2"
})(["", ""], MenuRowStyle);
export const MenuLikeLink = styled(LikeLink).withConfig({
  displayName: "MobileCardMenu__MenuLikeLink",
  componentId: "g7k8bx-3"
})(["", " font-weight:500;"], MenuRowStyle);
const MobileCardShareButton = shareButtonProps => /*#__PURE__*/_jsx(ShareButton, Object.assign({}, shareButtonProps, {
  render: button => /*#__PURE__*/_jsx(MenuRow, {
    children: button
  })
}));
const TrackLessonMenuOptions = ({
  trackId,
  lessonId,
  language = getLang(),
  onOpenChange,
  renderShareContentOption,
  children
}) => {
  const closeModal = () => onOpenChange(false);
  const onAddToPlaylistClick = () => {
    closeModal();
    UsageTracker.track('playlistInteraction', {
      action: 'add-to-playlist',
      location: 'card-menu',
      itemId: trackId || lessonId,
      language
    });
  };
  const onAddToNewPlaylistClick = () => {
    closeModal();
    UsageTracker.track('playlistInteraction', {
      action: 'add-to-new-playlist',
      location: 'card-menu',
      itemId: trackId || lessonId,
      language
    });
  };
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    useBackText: true,
    useSidePanel: true,
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      lessonId: lessonId,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      }),
      trackId: trackId
    }), /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(AddToPlaylist, {
        language: language,
        lessonId: lessonId,
        loadMode: "button",
        loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.cardMenu.loadMorePlaylists"
          })
        }),
        onPlaylistClick: onAddToPlaylistClick,
        renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PanelSection, {
            showBorders: false,
            title: /*#__PURE__*/_jsxs(UIFlex, {
              children: [/*#__PURE__*/_jsx(UIBox, {
                grow: 1,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyNav.heading.myPlaylists"
                })
              }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
                language: language,
                lessonId: lessonId,
                render: (linkContent, to) => /*#__PURE__*/_jsx(RouterLink, {
                  onClick: onAddToNewPlaylistClick,
                  to: to,
                  truncate: true,
                  children: linkContent
                }),
                trackId: trackId,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.cardMenu.addToNewPlaylist"
                })
              })]
            })
          }), content]
        }),
        renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
          children: content
        }, key),
        trackId: trackId
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.cardMenu.addToPlaylist"
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(CaretForward, {
          color: theme.colors.EERIE
        })
      })]
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      language: language,
      lessonId: lessonId,
      render: (linkContent, to) => /*#__PURE__*/_jsx(MenuLink, {
        onClick: onAddToNewPlaylistClick,
        to: to,
        truncate: true,
        use: "unstyled",
        children: linkContent
      }),
      trackId: trackId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.cardMenu.addToNewPlaylist"
      })
    }), renderShareContentOption ? renderShareContentOption(closeModal) : /*#__PURE__*/_jsx(MobileCardShareButton, {
      language: language,
      lessonId: lessonId,
      onClick: closeModal,
      trackId: trackId
    }), children]
  });
};
const menuItemStyle = {
  textDecoration: 'none',
  fontWeight: 'normal',
  width: '100%'
};
const PlaylistMenuOptions = ({
  playlistId,
  language = getLang(),
  onOpenChange,
  children
}) => {
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  const closeModal = () => onOpenChange(false);
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    useBackText: true,
    useSidePanel: true,
    children: [/*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(StartPlaylistButton, {
        appearsIn: "playlist",
        playlistId: playlistId,
        showLoader: true,
        style: menuItemStyle,
        use: "unstyled"
      })
    }), userIsOwner && /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(EditPlaylistButton, {
        playlistId: playlistId,
        style: menuItemStyle,
        use: "unstyled"
      })
    }), userIsOwner && /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ChangePlaylistThumbnail, {
          onItemClick: closeModal,
          playlistId: playlistId,
          renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(PanelSection, {
              showBorders: false,
              title: /*#__PURE__*/_jsx(UIFlex, {
                children: /*#__PURE__*/_jsx(UIBox, {
                  grow: 1,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "learningCenter.cardMenu.playlistItems"
                  })
                })
              })
            }), content]
          }),
          renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
            children: content
          }, key)
        }), /*#__PURE__*/_jsx("div", {
          className: "m-all-4",
          children: /*#__PURE__*/_jsx(UploadPlaylistThumbnailButton, {
            onImageUpload: closeModal,
            playlistId: playlistId,
            use: "tertiary"
          })
        })]
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.cardMenu.changeThumbnail"
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: "right"
      })]
    }), /*#__PURE__*/_jsx(MobileCardShareButton, {
      onClick: closeModal,
      playlistId: playlistId
    }), /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(AssignPlaylistButton, {
        playlistId: playlistId,
        style: menuItemStyle,
        tooltipProps: {
          placement: 'right'
        },
        use: "unstyled"
      })
    }), /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(PlaylistAssignmentsSearchProvider, {
        children: /*#__PURE__*/_jsx(UnAssignPlaylist, {
          loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
            children: /*#__PURE__*/_jsx(UnassignPlaylistLoadMore, {})
          }),
          onUnassigned: closeModal,
          playlistId: playlistId,
          renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(PanelSection, {
              showBorders: false,
              title: /*#__PURE__*/_jsx(UnassignPlaylistHeader, {})
            }), content]
          }),
          renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
            children: content
          }, key)
        })
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.unassignPlaylist"
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: "right"
      })]
    }), /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(DuplicatePlaylistButton, {
        playlistId: playlistId,
        style: menuItemStyle,
        use: "unstyled"
      })
    }), /*#__PURE__*/_jsx(SavePlaylistButton, {
      language: language,
      onClick: closeModal,
      playlistId: playlistId,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      }),
      style: {
        width: '100%'
      }
    }), /*#__PURE__*/_jsx(ArchivePlaylistButton, {
      language: language,
      onClick: closeModal,
      playlistId: playlistId,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      }),
      showTooltip: true,
      style: {
        width: '100%'
      }
    }), children]
  });
};
const ShortMenuOptions = ({
  shortId,
  language,
  onOpenChange,
  children
}) => {
  const closeModal = () => onOpenChange(false);
  const onAddToPlaylistClick = () => {
    closeModal();
    UsageTracker.track('playlistInteraction', {
      action: 'add-to-playlist',
      location: 'card-menu',
      itemId: shortId,
      language
    });
  };
  const onAddToNewPlaylistClick = () => {
    closeModal();
    UsageTracker.track('playlistInteraction', {
      action: 'add-to-new-playlist',
      location: 'card-menu',
      itemId: shortId,
      language
    });
  };
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    useBackText: true,
    useSidePanel: true,
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      language: language,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      }),
      shortId: shortId
    }), /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(AddToPlaylist, {
        language: language,
        loadMode: "button",
        loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.cardMenu.loadMorePlaylists"
          })
        }),
        onPlaylistClick: onAddToPlaylistClick,
        renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PanelSection, {
            showBorders: false,
            title: /*#__PURE__*/_jsxs(UIFlex, {
              children: [/*#__PURE__*/_jsx(UIBox, {
                grow: 1,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyNav.heading.myPlaylists"
                })
              }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
                language: language,
                render: (linkContent, to) => /*#__PURE__*/_jsx(RouterLink, {
                  onClick: onAddToNewPlaylistClick,
                  to: to,
                  truncate: true,
                  children: linkContent
                }),
                shortId: shortId,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.cardMenu.addToNewPlaylist"
                })
              })]
            })
          }), content]
        }),
        renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
          children: content
        }, key),
        shortId: shortId
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.cardMenu.addToPlaylist"
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(CaretForward, {
          color: theme.colors.EERIE
        })
      })]
    }), /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(MobileSocialShareMenuOption, {
        language: language,
        onShare: closeModal,
        shortId: shortId
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.common.share"
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(CaretForward, {
          color: theme.colors.EERIE
        })
      })]
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      language: language,
      render: (linkContent, to) => /*#__PURE__*/_jsx(MenuLink, {
        onClick: onAddToNewPlaylistClick,
        to: to,
        truncate: true,
        use: "unstyled",
        children: linkContent
      }),
      shortId: shortId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.cardMenu.addToNewPlaylist"
      })
    }), children]
  });
};
const MobileCardMenu = _ref => {
  let {
      children,
      isOpen,
      renderExtraOptions,
      playlistId,
      trackId,
      lessonId,
      shortId,
      language,
      onOpenChange
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, isOpen && /*#__PURE__*/_jsxs(_Fragment, {
      children: ["(", playlistId && /*#__PURE__*/_jsx(PlaylistMenuOptions, Object.assign({
        onOpenChange: onOpenChange,
        playlistId: playlistId
      }, props, {
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      })), (trackId || lessonId) && /*#__PURE__*/_jsx(TrackLessonMenuOptions, Object.assign({
        language: language,
        lessonId: lessonId,
        onOpenChange: onOpenChange,
        trackId: trackId
      }, props, {
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      })), shortId && language && /*#__PURE__*/_jsx(ShortMenuOptions, Object.assign({
        language: language,
        onOpenChange: onOpenChange,
        shortId: shortId
      }, props, {
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      })), ")"]
    })]
  });
};
export default MobileCardMenu;